<template>
  <v-card>
    <v-card-text class="text-center">
      This site may only be accessed via the Nexus Connect Inbox.
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NullLanding",
};
</script>
